import EditorJS from '@editorjs/editorjs';
import { InstructionCSSClasses, InstructionEvent } from '../types';
import {
  emitInstructionEventByEditor,
  getInstructionFromSpan,
  removeInlineInstructionWrapper,
  renderExclamationIcon
} from '../utils';
import { detectIOS } from '../../../../utility/helpers';

export const addEventListenerToAudioActions = async (
  params: {
    instanceEditor: EditorJS;
    refEditor: HTMLDivElement;
  },
) => {
  const { instanceEditor, refEditor } = params;

  const actionHandler = (event: MouseEvent | TouchEvent) => {
    const mappedTarget = event.target as HTMLSpanElement;
    const instructionId = getInstructionFromSpan(mappedTarget);
    if (instructionId) {
      emitInstructionEventByEditor(
        instanceEditor,
        InstructionEvent.OPEN_AUDIO_INSTRUCTION_MODAL,
        {
          instructionId,
          isInline: true,
        },
      );
    }
  };

  instanceEditor.isReady.then(() => {
    const actions = refEditor.querySelectorAll<HTMLSpanElement>(
      `.${InstructionCSSClasses.AUDIO_INSTRUCTION_ACTION}`,
    );
    actions.forEach((item) => {
      const instructionId = getInstructionFromSpan(item);
      if (instructionId) {
        renderExclamationIcon(item, instructionId);
        if (item.parentElement) {
          removeInlineInstructionWrapper(item.parentElement);
        }
      }
      if (detectIOS()) {
        // eslint-disable-next-line
        item.onmouseenter = actionHandler;
      }
      // eslint-disable-next-line
      item.onclick = actionHandler;
    });
  });
};
